import { Box, Button, Typography, SvgIcon } from "@mui/material";
import React, { useCallback, useEffect, Fragment, useRef, useState, useTransition } from "react";
import { useTranslation } from "react-i18next";
import Layout from "../../components/layout/Layout";
import Divider from "@mui/material/Divider";

import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  addPlaylist,
  deletePlaylist,
  findOne,
  getPlaylistsById,
  updateDuration,
  editPlaylistName,
  addContentLocally,
  deleteContentLocally,
  playlistFlagOff,
  editPlaylistDemoAttribute,
} from "../../redux/actions/Playlist";

import Container from "@mui/material/Container";
import Grid from "@mui/material/Unstable_Grid2";
import Stack from "@mui/material/Stack";

import { useMediaQuery } from "react-responsive";
import toast from "react-hot-toast";
import AddPlaylistModal from "./component/AddPlaylistModal";
import SelectFilesModal from "../../components/selectfilesmodal/SelectFilesModal";

import { useDialog } from "src/hooks/use-dialog";

import { OrderDrawer } from "./component/order-drawer";
import { OrderListContainer } from "./component/order-list-container";
import { OrderListSearch } from "./component/order-list-search";
import { OrderListTable } from "./component/order-list-table";
import { useSettings } from "src/hooks/use-settings";
import ConfirmPlaylistDelete from "./component/ConfirmPlaylistDelete";
import { api } from "src/api/endpoints";

function RedesignPlaylist({ socketRef, user }) {
  const { t } = useTranslation();
  const rootRef = useRef(null);
  const settings = useSettings();

  const dialog = useDialog();
  const dispatch = useDispatch();
  const findOnePlaylistAndActive = (id) => {
    dispatch(findOne(id));
  };

  const handleDrawerOpen = (id) => {
    findOnePlaylistAndActive(id);
    if (dialog.open && dialog.data === id) {
      dialog.handleClose();
      return;
    }

    dialog.handleOpen(id);
  };

  const { playlists, playlist, isOnePlaylist, isPlaylistLoaded, isContentAdded, isPlaylistContentSorted, duplicateNamesError } = useSelector((state) => ({
    playlists: state.Playlist.playlists,
    playlist: state.Playlist.playlist,
    isOnePlaylist: state.Playlist.isOnePlaylist,
    isPlaylistLoaded: state.Playlist.isPlaylistLoaded,
    isContentAdded: state.Playlist.isContentAdded,
    isPlaylistContentSorted: state.Playlist.isPlaylistContentSorted,
    duplicateNamesError: state.Playlist.duplicateNamesError
  }), shallowEqual);
  const { screens } = useSelector((state) => state.Screen, shallowEqual);
  const { content } = useSelector((state) => state.Content, shallowEqual);
  const [search, setSearch] = useState("");
  const [opneCreatePlaylist, setOpenCreatePlaylist] = useState(false);
  const [openFolder, setOpenFolder] = useState(false);
  const [playlistName, setPlaylistName] = useState("");
  const [defaultPlaylist, setDefaultPlaylist] = useState(false);
  const [foldername, setFolderName] = useState("");
  const [playlistControlOption, setPlaylistControlOption] = useState(false);
  const [openTimeModel, setOpenTimeModel] = useState(false);
  const [openSelectFiles, setOpenSelectFiles] = useState(false);
  const [time, setTime] = useState(0);
  const [contentId, setContentId] = useState("");
  const [anyId, setAnyId] = useState("");
  const [playlistId, setPlaylistId] = useState("");
  const [openPlaylist, setOpenPlaylist] = useState(false);
  const [isOver, setIsOver] = useState(false);
  const [overContent, setOverContent] = useState(false);
  const [contentObjectValue, setContentObjectValue] = useState({});
  const [lastContentId, setLastContentId] = useState("");
  const [isMainContent, setIsMainContent] = useState(false);
  const [one, setOne] = useState({});
  const [items, setItems] = useState([]);
  const [openConfirmPlaylitsDelete, setOpenConfirmPlaylitsDelete] = useState(false)
  const [isPending, startTransition] = useTransition();
  // console.log(playlists);
  useEffect(() => {
    setItems(playlists);
  }, [playlists]);

  useEffect(() => {
    if (user?.isMember) {
      dispatch(getPlaylistsById(user?.user?._id));
    } else {
      dispatch(getPlaylistsById(user?._id));
    }
  }, []);

  useEffect(() => {
    if (isPlaylistLoaded) {
      dispatch(findOne(playlists[0]?._id));
      dispatch(playlistFlagOff());
    }
    if (isContentAdded) {
      toast.success(t("views.redesignPlaylist.contentAddedSuccess"));
      // emitOnAddedContentInPlaylist();
      dispatch(playlistFlagOff());
    }
    if (isPlaylistContentSorted) {
      toast.success(t("views.redesignPlaylist.contentSortedSuccess"));
      // emitOnAddedContentInPlaylist();
      dispatch(playlistFlagOff());
    }
  }, []);

  useEffect(() => {
    if(duplicateNamesError){
      toast.error(t("views.redesignPlaylist.playlistAlreadyExistsName"))
    }
  }, [duplicateNamesError])

  useEffect(() => {
    if (isOnePlaylist) {
      setPlaylistId(playlist._id);
      setOne({ ...playlist });
      dispatch(playlistFlagOff());
    }
  }, []);

  const onSelectFiles = () => {
    setOpenSelectFiles(true);
  };

  const savePlaylist = () => {
    if (playlistName === "" || playlistName === undefined) {
      return;
    }
      // console.log(defaultPlaylist);
    if(playlistName.length < 41){
      if (user?.isMember) {
        dispatch(
          addPlaylist({
            playlistName,
            defaultPlaylist,
            user: user.user._id,
            role: user?.user?.role,
          })
        );
      } else {
        dispatch(
          addPlaylist({
            playlistName,
            defaultPlaylist,
            user: user?._id,
            subuser: user?._id,
            role: user?.role,
          })
        );
      }
      setOpenPlaylist(false);
      setPlaylistName("");
      setDefaultPlaylist(false);
    }else{
      toast.error(t("views.redesignPlaylist.charsCountError"));
    }
  };

  const onSaveFiles = (ids, files = []) => {
    dispatch(addContentLocally(playlist._id, files));
  };

  const deleteContentFromPlaylist = (obj) => {
    dispatch(deleteContentLocally(obj.playlistId, obj.contentId));
  };

  const saveDurationChange = (time, playlistid, playlistContentId) => {
    dispatch(
      updateDuration({
        time: time,
        playlistId: playlistid,
        contentId: playlistContentId,
      })
    );
    const s = screens.find((c) => c?.playlist?._id === playlistid);
    if (s !== undefined || s !== null) {
      // emitOnTimeDurationChangedInPlaylist(s?.mac);
    }
  };

  const onSetDemoPlaylist = (id, isDemo) => {
    dispatch(editPlaylistDemoAttribute(id, !isDemo));
  };

  const deletePlaylists = async () => {
    // console.log(playlist._id + " " + playlist.playlistName);
    try {
      const screensGetRes = await api.get(`/screen/getScreensByPlaylist/${playlist._id}`)
      if(screensGetRes.data.screens?.length > 0){
        setOpenConfirmPlaylitsDelete(true)
      }else{
        dispatch(deletePlaylist([playlist._id]));
      }
    } catch (err) {
      toast.error("Error while removing playlist")
    }
    // emitOnDeletePlaylist([id]);
  };

  const editPlaylistNameSave = (id, playlistName) => {
    dispatch(editPlaylistName(id, playlistName));
  };

  const handleSearchChange = useCallback(
    (value) => {
      if (playlists && playlists.length > 0) {
        startTransition(() => {
          setItems(playlists.filter((item) => item.playlistName.toLowerCase().includes(value)));
        });
      }
    },
    [playlists]
  );

  const handleSortChange = useCallback(
    (value) => {
      // console.log(value);

      startTransition(() => {
        if (value == "date_desc" || value == "date_asc") {
          setItems(playlists.reverse());
        } else if (value == "name_asc") {
          setItems(playlists.sort((a, b) => a.playlistName.localeCompare(b.playlistName)));
        } else if (value == "name_desc") {
          setItems(playlists.sort((a, b) => -1 * a.playlistName.localeCompare(b.playlistName)));
        }
      });
    },
    [items, playlists]
  );

  const onPlaylistAdd = () => {
    setOpenPlaylist(true);
  };

  const onSync = () => {
    for (const p in playlist.screen_mac) {
      socketRef?.current.emit(
        "sync",
        {
          detail: { mac: playlist.screen_mac[p].mac },
        },
        function () {}
      );
    }

    toast.success(t("views.redesignScreens.syncSuccess"));
  };

  return (
    <Fragment>
      <Layout title={t("views.redesignPlaylist.title")} user={user}>
        <Box component="main">
          <Container maxWidth={settings.stretch ? false : "xl"}>
            <OrderListSearch onFiltersChange={handleSearchChange} onSortChange={handleSortChange} onPlaylistAdd={onPlaylistAdd} />
            <OrderListTable items={items} onSelect={(id) => handleDrawerOpen(id)} />
            <OrderDrawer
              onClose={dialog.handleClose}
              open={dialog.open}
              order={playlist}
              orders={playlists}
              onSelectFiles={onSelectFiles}
              deletePlaylists={deletePlaylists}
              editPlaylistNameSave={editPlaylistNameSave}
              saveDurationChange={saveDurationChange}
              onSync={onSync}
              deleteContentFromPlaylist={deleteContentFromPlaylist}
              isAdmin={user?.role === "admin" || false}
              onSetDemoPlaylist={onSetDemoPlaylist}
            />
          </Container>
        </Box>
      </Layout>

      <SelectFilesModal
        // open={openSelectFiles}
        // onClose={() => setOpenSelectFiles(false)}
        // setOpenSelectFiles={setOpenSelectFiles}
        // files={content}
        // playlist={playlist}
        // onSaveFiles={onSaveFiles} 
        onSelectFiles={onSaveFiles}
        open={openSelectFiles}
        setOpen={() => setOpenSelectFiles(false)}
        filesToExclude={playlist?.content?.map(c => {
          if(c.content){
            return c.content._id
          }
        })}
      />

      <AddPlaylistModal
        openCreatePlaylist={openPlaylist}
        value={playlistName}
        textValue={(e) => setPlaylistName(e)}
        onClose={(e) => setOpenPlaylist(e)}
        savePlaylist={savePlaylist}
        isAdmin={user?.role === "admin" || false}
        defaultPlaylist={defaultPlaylist}
        setDefaultPlaylist={setDefaultPlaylist}
      />

      <ConfirmPlaylistDelete open={openConfirmPlaylitsDelete} handleClose={() => setOpenConfirmPlaylitsDelete(false)} playlistId={playlist?._id}/>
    </Fragment>
  );
}

export default RedesignPlaylist;
